import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-access-gate',
  templateUrl: './access-gate.component.html',
  styleUrls: ['./access-gate.component.scss']
})
export class AccessGateComponent {
  mode: 'invite' | 'email' = 'invite';
  inviteCode = '';
  email = '';
  submitting = false;
  errorMessage = '';

  constructor(private http: HttpClient, private auth: AuthService) {}

  setMode(mode: 'invite' | 'email'): void {
    this.mode = mode;
    this.errorMessage = '';
  }

  submit(): void {
    const value = this.mode === 'invite' ? (this.inviteCode || '').trim() : (this.email || '').trim();
    if (!value) {
      this.errorMessage = 'Please enter a value to continue.';
      return;
    }
    this.submitting = true;
    this.errorMessage = '';
    this.http.post<{ ok?: boolean }>(`${environment.apiBaseUrl}/public/access-gate/verify`, {
      type: this.mode,
      value
    }).subscribe({
      next: () => {
        this.submitting = false;
        this.auth.markSiteAccessGranted();
        this.auth.continueAfterGate();
      },
      error: () => {
        this.submitting = false;
        this.errorMessage = 'Access denied. Check your invite code or email and try again.';
      }
    });
  }
}
